
import { Company } from '@/lib/types/trek-types';

/**
 * Map database schema to Company frontend model
 */
export function mapDbSchemaToCompany(dbCompany: any): Company {
  return {
    id: dbCompany.id,
    name: dbCompany.name,
    description: dbCompany.description,
    foundedYear: dbCompany.founded_year,
    rating: dbCompany.rating,
    reviewCount: dbCompany.review_count ?? 0, // Ensure reviewCount is never null/undefined
    headquarters: dbCompany.headquarters ?? '',
    primaryHighlights: dbCompany.primary_highlights ?? [],
    specialties: dbCompany.specialties ?? [],
    safetyRecord: dbCompany.safety_record ?? '',
    certifications: dbCompany.certifications ?? [],
    sustainabilityInitiatives: dbCompany.sustainability_initiatives ?? [],
    logo: dbCompany.logo,
    is_active: dbCompany.is_active ?? true,
    is_featured: dbCompany.is_featured ?? false,
    website: dbCompany.website ?? '',
    priority: dbCompany.priority
  };
}

/**
 * Map Company frontend model to database schema
 */
export function mapCompanyToDbSchema(company: Partial<Company>) {
  return {
    id: company.id,
    name: company.name,
    description: company.description,
    founded_year: company.foundedYear,
    rating: company.rating,
    review_count: company.reviewCount ?? 0, // Ensure review_count is never null/undefined
    headquarters: company.headquarters ?? '',
    primary_highlights: company.primaryHighlights ?? [],
    specialties: company.specialties ?? [],
    safety_record: company.safetyRecord ?? '',
    certifications: company.certifications ?? [],
    sustainability_initiatives: company.sustainabilityInitiatives ?? [],
    logo: company.logo,
    is_active: company.is_active ?? true,
    is_featured: company.is_featured ?? false,
    website: company.website ?? '',
    priority: company.priority
  };
}
